import React, { useContext, useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';

import { AppContext } from '@/AppContext';
import { Route, useParams } from 'react-router-dom';
import PurchasesToolbar from './components/PurchasesToolbar';
import PurchasesTable from './components/PurchasesTable';

const PREFIX = 'PurchaseList';

const classes = {
  root: `${PREFIX}-root`,
  content: `${PREFIX}-content`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.root}`]: {
    padding: theme.spacing(3),
  },

  [`& .${classes.content}`]: {
    marginTop: theme.spacing(2),
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const PurchaseList = () => {
  const appContext = useContext(AppContext);

  const { mid: meetupId } = useParams();

  const [refreshCounter, setRefresh] = useState(0);
  const [info, setInfo] = useState();

  useEffect(() => {
    appContext.merchApi
      .listPurchases(meetupId)
      .then(({ data }) => {
        setInfo(data);
      })
      .catch(appContext.errorHandler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meetupId, refreshCounter]);

  if (!info) {
    return null;
  }

  return (
    <Root>
      <PurchasesToolbar meetupId={meetupId} info={info} />
      <PurchasesTable meetupId={meetupId} purchases={info.purchases} />
    </Root>
  );
};

export default PurchaseList;
